var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "btn-group table-status",
      attrs: { "data-toggle": "buttons" }
    },
    _vm._l(_vm.options, function(option, idx) {
      return _c(
        "label",
        {
          key: option.id,
          class: [
            "btn",
            "btn-radio",
            option.flavor,
            option.id == _vm.value ? "active" : ""
          ],
          attrs: { for: _vm.getInputKey(idx) },
          on: {
            click: function($event) {
              return _vm.onUpdate(option)
            }
          }
        },
        [
          _c("input", {
            staticClass: "mr-1",
            attrs: {
              type: "radio",
              autocomplete: "off",
              id: _vm.getInputKey(idx),
              name: _vm.getInputKey()
            },
            domProps: { checked: option.id == _vm.value, value: option.id },
            on: { input: _vm.onInput }
          }),
          _vm._v(" " + _vm._s(option.name) + "\n    ")
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08cde6ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08cde6ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/CustomFlavorRadioComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-08cde6ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/CustomFlavorRadioComponent.vue
// module chunks = 0